import { useNavigate } from "react-router-dom";

const PrivacyPolicyComponent = () => {
  const navigate = useNavigate();
  return (
    <div className="py-md-5 py-2 text-center">
      {/* <div className="avatar-xl mx-auto">
      <div className="avatar-title bg-soft-primary text-primary h1 rounded-circle">
        <i className="bx bxs-user"></i>
      </div>
    </div> */}
      <div className="mt-0 pt-0">
        <h5>นโยบายคุมครองข้อมูลส่วนบุคคล</h5>

        <div className="iframe-privacy-container">
          <iframe src="https://chat.2smetal.com/Personal-Data-Protection-Policy.pdf"></iframe>
          {/* <iframe src="https://docs.google.com/gview?url=https://chat.2smetal.com/Personal-Data-Protection-Policy.pdf&embedded=true" ></iframe> */}

        </div>
        <div className="mt-0">

          <button onClick={() => navigate(-1)} className="btn btn-primary">
            ย้อนกลับ
          </button>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyComponent;